/* Matres pixel tracking — Google Ads (gtag) + Meta + TikTok + Snapchat.
 * Base pixels are initialised in snippets/matres-pixels-head.liquid with IDs
 * from theme settings. This module fires the standard e-commerce events,
 * mirroring the Lovable app (src/lib/analytics.ts), including the Google Ads
 * conversion labels for AW-18241496210. Meta/TikTok events carry a dedup id
 * (eventID / event_id) for server-side matching. Consent is honoured via
 * Shopify's Customer Privacy API when present. Purchase fires from the
 * checkout Custom Pixel (docs/custom-pixel.js), not from here.
 */
(function () {
  var CURRENCY = (window.MATRES && window.MATRES.currency) || 'QAR';
  var IDS = window.MATRES_PIXELS || {};

  // Conversion labels for the Matres Google Ads account (AW-18241496210).
  var ADS_LABELS = {
    pageView: 'WvwFCJDmj8AcEJLJnPpD',
    viewItem: '2eVbCJPmj8AcEJLJnPpD',
    addToCart: 'ef7OCI3mj8AcEJLJnPpD',
    beginCheckout: 'MEZ1CIrmj8AcEJLJnPpD',
    search: '0toMCJbmj8AcEJLJnPpD',
    purchase: 'EMUGCIfmj8AcEJLJnPpD'
  };

  function canTrack() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.userCanBeTracked === 'function') return cp.userCanBeTracked();
    } catch (e) {}
    return true; // default allow when the API isn't available
  }

  function uid() {
    try {
      if (window.crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '').slice(0, 16);
    } catch (e) {}
    return Math.random().toString(16).slice(2, 18);
  }

  function gtagSafe() {
    if (!canTrack() || typeof window.gtag !== 'function') return null;
    return window.gtag;
  }
  function adsConversion(label, params) {
    var g = gtagSafe();
    if (!g || !IDS.googleAds || !ADS_LABELS[label]) return;
    try { g('event', 'conversion', Object.assign({ send_to: IDS.googleAds + '/' + ADS_LABELS[label] }, params || {})); } catch (e) {}
  }
  function gaEvent(name, params) {
    var g = gtagSafe();
    if (!g) return;
    try { g('event', name, params || {}); } catch (e) {}
  }
  function fbTrack(name, params) {
    if (!canTrack() || typeof window.fbq !== 'function') return;
    try { window.fbq('track', name, params || {}, { eventID: uid() }); } catch (e) {}
  }
  function ttTrack(name, params) {
    if (!canTrack() || !window.ttq || typeof window.ttq.track !== 'function') return;
    try { window.ttq.track(name, params || {}, { event_id: uid() }); } catch (e) {}
  }
  function snapTrack(name, params) {
    if (!canTrack() || typeof window.snaptr !== 'function') return;
    try { window.snaptr('track', name, params || {}); } catch (e) {}
  }

  // items: [{ id, quantity, price, name }]
  function gaItems(items) {
    return items.map(function (i) {
      return { item_id: i.id, item_name: i.name, price: i.price, quantity: i.quantity || 1 };
    });
  }
  function metaContents(items) { return items.map(function (i) { return { id: i.id, quantity: i.quantity || 1 }; }); }
  function metaIds(items) { return items.map(function (i) { return i.id; }); }
  function ttContents(items, fallbackName) {
    return items.map(function (i) {
      return { content_id: i.id, content_type: 'product', content_name: i.name || fallbackName, quantity: i.quantity || 1, price: i.price };
    });
  }
  function snapIds(items) { return items.map(function (i) { return i.id; }); }

  window.MatresPixels = {
    viewContent: function (o) {
      var items = o.items || [];
      gaEvent('view_item', { currency: CURRENCY, value: o.value, items: gaItems(items) });
      adsConversion('viewItem', { value: o.value, currency: CURRENCY });
      fbTrack('ViewContent', { content_name: o.contentName, content_ids: metaIds(items), content_type: 'product', contents: metaContents(items), value: o.value, currency: CURRENCY });
      ttTrack('ViewContent', { contents: ttContents(items, o.contentName), content_type: 'product', content_name: o.contentName, value: o.value, currency: CURRENCY });
      snapTrack('VIEW_CONTENT', { item_ids: snapIds(items), price: o.value, currency: CURRENCY });
    },
    addToCart: function (o) {
      var items = o.items || [];
      gaEvent('add_to_cart', { currency: CURRENCY, value: o.value, items: gaItems(items) });
      adsConversion('addToCart', { value: o.value, currency: CURRENCY });
      fbTrack('AddToCart', { content_name: o.contentName, content_ids: metaIds(items), content_type: 'product', contents: metaContents(items), value: o.value, currency: CURRENCY });
      ttTrack('AddToCart', { contents: ttContents(items, o.contentName), content_type: 'product', content_name: o.contentName, value: o.value, currency: CURRENCY });
      snapTrack('ADD_CART', { item_ids: snapIds(items), price: o.value, currency: CURRENCY });
    },
    viewCart: function (o) {
      var items = o.items || [];
      gaEvent('view_cart', { currency: CURRENCY, value: o.value, items: gaItems(items) });
    },
    initiateCheckout: function (o) {
      var items = o.items || [];
      var numItems = items.reduce(function (a, i) { return a + (i.quantity || 1); }, 0);
      gaEvent('begin_checkout', { currency: CURRENCY, value: o.value, items: gaItems(items) });
      adsConversion('beginCheckout', { value: o.value, currency: CURRENCY });
      fbTrack('InitiateCheckout', { content_ids: metaIds(items), content_type: 'product', contents: metaContents(items), value: o.value, num_items: numItems, currency: CURRENCY });
      ttTrack('InitiateCheckout', { contents: ttContents(items, o.contentName), content_type: 'product', value: o.value, currency: CURRENCY });
      snapTrack('START_CHECKOUT', { item_ids: snapIds(items), price: o.value, currency: CURRENCY });
    },
    search: function (query) {
      gaEvent('search', { search_term: query });
      adsConversion('search', {});
      fbTrack('Search', { search_string: query });
      ttTrack('Search', { query: query });
      snapTrack('SEARCH', { search_string: query });
    }
  };
})();
